import {parseBoolean, parseJSON, PropsParser, requireString} from "@webng/validations";
import {
  LiveblogCoreWidgetInitialData,
  LiveblogThemeConfiguration,
  SharedThemeConfiguration,
} from "@webng-types/embedjs";
import {AdManager} from "../../ads/AdManager";
import {LiveblogData} from "./liveblogDataReducer";
import {LiveblogRenderPortal, LiveblogRenderPortalTypes} from "@webng/liveblog";


export interface LiveblogCoreWidgetTagProps {
  liveblogId: string
  clientId: string
  initialData: LiveblogCoreWidgetInitialData
  css: string
  customerConsent: boolean
  disableTracking: boolean
  relativeLinkBaseUrl: string
}

export interface LiveblogCoreWidgetQueryProps {
  eventId: string
}

export interface LiveblogCoreWidgetProps extends LiveblogCoreWidgetTagProps, LiveblogCoreWidgetQueryProps {
  liveblogThemeConfiguration: LiveblogThemeConfiguration
  sharedThemeConfiguration: SharedThemeConfiguration
  themeId?: string
}
//
// export const defaultLiveblogWidgetTagProps: LiveblogCoreWidgetTagProps = {
//
//   css: ""
// }

export const liveblogCoreWidgetTagPropsParser: PropsParser<LiveblogCoreWidgetTagProps> = {
  clientId: i => requireString("clientId", i),
  liveblogId: i => requireString("liveblogId", i),
  initialData: i => parseJSON("initialData", i, {}),
  css: i => i || "",
  customerConsent: i => parseBoolean('customerConsent', i, false),
  disableTracking: i => parseBoolean('disableTracking', i, false),
  relativeLinkBaseUrl: i => i || ""
}

export const LiveblogCoreWidgetQueryPropsParser: PropsParser<LiveblogCoreWidgetQueryProps> = {
  eventId: i => i || ""
}

export interface NavigateToEventIdOptions {
  topOffset?: number
}

export interface LiveblogCoreApi {
  loadMoreTop: () => PromiseLike<void>
  loadMoreBottom: () => PromiseLike<void>
  navigateToEventId: (eventId: string, options?: NavigateToEventIdOptions) => PromiseLike<boolean>
  hasEventIdLoaded: (eventId: string) => boolean
  setConsent: (provider: string, consent: boolean) => void
  setAdManager: (newAdManager: AdManager) => void
  getCurrentLiveblogData: () => LiveblogData
  registerPortalForType: (type: LiveblogRenderPortalTypes, portal: LiveblogRenderPortal) => void
  unregisterPortalForType: (type: LiveblogRenderPortalTypes, portal: HTMLElement) => void
}
